import { computed, defineComponent, inject, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import ErrorMessage from "../../Shared/ErrorMessage";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { ErrorMessage },
  setup() {
    // Injections
    const { t } = useI18n();
    const currentOrderProvider = inject(currentOrderProviderKey);
    const orderService = inject(orderServiceKey);

    // vars und computed
    const orderContext = computed(
      () => currentOrderProvider?.currentOrderContext?.value ?? null,
    );
    const visible = computed(
      () =>
        (orderContext.value?.ask_cart_source ?? false) &&
        0 < (orderContext.value?.sources?.length ?? 0),
    );
    const sortedSources = computed(() =>
      [...(orderContext.value?.sources ?? [])].sort((a, b) => a.pos - b.pos),
    );

    const error = ref("");
    const sourceId = ref<number | null>(null);
    // source_id wird vom Backend nicht in der Order zurückgegeben, daher wird beim
    // ersten Laden der sources auf den als Default markierten Eintrag initialisiert.
    let initialized = false;
    watch(
      sortedSources,
      (sources) => {
        if (!initialized && 0 < sources.length) {
          sourceId.value = sources.find((s) => s.is_default)?.id ?? sources[0].id;
          initialized = true;
        }
      },
      { immediate: true },
    );

    // methods
    const handleChange = async () => {
      error.value = "";
      try {
        await orderService?.orderUpdate(null, null, sourceId.value);
      } catch (err) {
        error.value = err instanceof Error ? err.message : String(err);
      }
    };

    return {
      t,
      visible,
      sortedSources,
      sourceId,
      error,
      handleChange,
    };
  },
} as any);
